enum ConnectionType {
  EXCEL_ONLINE = 'EXCEL_ONLINE',
  GOOGLE_SHEETS = 'GOOGLE_SHEETS'
}

export default ConnectionType
